import { Link } from "react-router-dom";
import { trackEvent } from "../../../analytics";
interface LegacyPlanningProps {
  redirectUrl: string;
}
const LegacyPlanning = ({ redirectUrl }: LegacyPlanningProps) => {
  return (
    <div className="rounded-[12px] w-fit bg-white p-6">
      <div className="flex items-center gap-2">
        <h1 className="text-[22px] font-bold">Legacy Planning</h1>
        <img
          src="/assets/money/investmentOptions.png"
          alt="investment options"
          className="w-fit h-[11.5px] object-cover"
        />
      </div>
      <div className="bg-[linear-gradient(57deg,#090909_1%,#292929_98%)] text-white p-6 rounded-[10px] w-full mt-4 relative overflow-hidden">
        <img
          src="/assets/money/will-icon.webp"
          alt="legacy planning"
          className="absolute -right-10 w-[250px] top-[20px]"
        />

        <h6 className="text-black bg-[#ffd93f] rounded-[17px] text-[12px] py-1 px-3 w-fit font-[500] mb-2">
          Powered by Yellow Will
        </h6>
        <h2 className="text-[22px] font-bold w-2/3 pt-3">
          Make Your Legal Will
        </h2>
        <h4 className="text-[15px] w-2/3 mt-2">
          Create your will online in 15 minutes. Protect your family’s future.
        </h4>
        <Link
          to={redirectUrl}
          onClick={() => {
            trackEvent("protect_cta_clicked", { cta_for: "wills" });
          }}
        >
          <button className="bg-[#007aff] py-[8px] px-[16px] text-[15px] rounded-full leading-[1.33] mt-[24px] font-bold">
            Know more
          </button>
        </Link>
      </div>
    </div>
  );
};

export default LegacyPlanning;
